import script from "./Credits.vue?vue&type=script&setup=true&lang=js"
export * from "./Credits.vue?vue&type=script&setup=true&lang=js"

const __exports__ = script;

export default __exports__